import { render } from "./question_based_authentication.html?vue&type=template&id=3cc25440&external"
import script from "./question_based_authentication.js?vue&type=script&lang=js&external"
export * from "./question_based_authentication.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__